<template>
     <div class="container">
       <div class="sticky">
         <div id="gameheader" class="container">
           <div class="flex-box">
          <div class="component-timer">
            <div class="topwatch"></div>
            <div id="timer">
                <span id="minutes">{{ minutes }}</span>
                <span id="middle">:</span>
                <span id="seconds">{{ seconds }}</span>
            </div>
            <div v-show="timemodalshow && timeflag" class="alarm-mask">
                  <div class="alarm-wrapper">
                    <div class="alarm-container">
                      <span id="minutes">{{ minutes }}</span>
                      <span id="middle">:</span>
                      <span id="seconds">{{ seconds }}</span>
                      <p v-if="this.totalTime != 0">마감시간까지 5분 남았습니다.</p>
                      <p v-else>게임이 끝났습니다!</p>
                      <button v-if="this.totalTime != 0" class="alarm-button" @click="timeflag = false">
                        OK
                      </button>
                      <router-link v-else class="alarm-button" to="/final" @click.native.prevent="loadforEditArticle">
                        END GAME
                      </router-link >
                    </div>
                  </div>
            </div>
          </div>
          <div class="component-mypage">
            <mypage :levelid="level" :pointprops="get_totalpoint"></mypage>
          </div>
          <div class="component-point">
            <div class="topstar"></div>
            <p>{{ get_totalpoint }}P</p>
            <levelup :levelid="level" v-show="showlevelupmodal" @close="showlevelupmodal = false" ></levelup>
            <badge></badge>
          </div>
         </div>
          </div>
       </div>
       <router-view class="game-body"></router-view>
    </div>
</template>

<script>
/* eslint-disable */
import mypage from './mypage.vue'
import levelup from './levelupModal'
import badge from './badgeModal'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
	components :{
    mypage,
    levelup,
    badge
  },
	data () {
		return {
    //timer: null,
    totalTime: this.$store.getters.get_totaltime,
    point: this.$store.getters.get_totalpoint,
    timemodalshow: false,
    timeflag: true,
    showlevelupmodal: false,
    level: 0,
    levelupcount: 1,
		}
	},
	created(){
      this.$store.dispatch('loadTotalpoint')
      this.$store.dispatch('loadTime')
      this.$store.dispatch('loadSectionState')
 },
mounted(){
        this.$store.dispatch('loadArticles')
        this.$store.dispatch('loadLinksArticle')
        this.$store.dispatch('loadClues')
        this.$store.dispatch('loadfwoh')
        this.setlevelcount()
        this.startTimer()
    },
  // ========================
  methods: {
    startTimer: function() {
      this.timer = setInterval(() => this.countdown(), 1000);
    },
    stopTimer: function() {
      clearInterval(this.timer);
      this.timer = null;
    },
    padTime: function(time) {
      return (time < 10 ? '0' : '') + time;
    },
    countdown: function() {
      if(this.totalTime >= 1){
        this.totalTime--;
        this.$store.commit('timeticken')
        if (this.totalTime <= 5*60){
          this.timemodalshow = true;
        }
      }
      else{
        this.totalTime = 0;
        this.timemodalshow = true
        this.timeflag = true
      }
    },
    setlevelcount: function () {
      console.log('setlevelcount')
      if (this.get_totalpoint >= 12000){
        this.levelupcount = 4
        this.level = 4
        this.$store.commit('updateLevelid', 4)
      }
      else if (this.get_totalpoint >= 8000){
        this.levelupcount = 3
        this.level = 3
        this.$store.commit('updateLevelid', 3)
      }
      else if (this.get_totalpoint >= 4000){
        this.levelupcount = 2
        this.level = 2
        this.$store.commit('updateLevelid', 3)
      }
      else if (this.get_totalpoint >= 2000){
        this.levelupcount = 1
        this.level = 1
        this.$store.commit('updateLevelid', 1)
      }
      else{
        this.levelupcount = 1
      }
    },
    loadforEditArticle(){
        this.$store.dispatch('loadforEditArticle')
    }
    //setbadgeflag
  },
  // ========================
  computed: {
    minutes: function() {
      const minutes = Math.floor(this.totalTime / 60);
      return this.padTime(minutes);
    },
    seconds: function() {
      const seconds = this.totalTime - (this.minutes * 60);
      return this.padTime(seconds);
    },
    ...mapGetters([
      'session_PE',
      'get_totalpoint',
      'get_totaltime',
      'sectionStates'
    ])
  },
watch: {
    get_totalpoint: function (newVal) {
      if(newVal >= 2000 && this.levelupcount == 1) {
        this.level = 1
        this.$store.commit('updateLevelid', 1)
        this.showlevelupmodal = true
        this.levelupcount = 2
      }
      else if (newVal >= 4000 && this.levelupcount == 2){
        this.level = 2
        this.$store.commit('updateLevelid', 2)
        this.showlevelupmodal = true
        this.levelupcount = 3
      }
      else if (newVal >= 8000 && this.levelupcount == 3){
        this.level = 3
        this.$store.commit('updateLevelid', 3)
        this.showlevelupmodal = true
        this.levelupcount = 4
      }
       else if (newVal >= 12000 && this.levelupcount == 4){
        this.level = 4
        this.$store.commit('updateLevelid', 4)
        this.levelupcount = 5
      }
    },
}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/game.vue